import { PatternApprovalDashboardDto, StatusEnumDto, TestingCalibrationDashboardDto } from '../../api/web-api-client';

export interface Filters {
    year?: number;
    status?: StatusEnumDto;
    sortOrder?: string;
}

export interface InitialFilters {
    filterYearType: string;
    filterStatusType: string;
    filtersChanged: boolean;

}

export interface SearchFilterProps {
    containerClassName?: string;
    className?: string;
    initialFilters: TestingCalibrationDashboardDto | undefined;
    setInitialFilters: React.Dispatch<React.SetStateAction<TestingCalibrationDashboardDto | undefined>>;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
    placeholder?: string;
}

export interface PaSearchFilterProps {
    containerClassName?: string;
    className?: string;
    initialFilters: PatternApprovalDashboardDto;
    setInitialFilters: React.Dispatch<React.SetStateAction<PatternApprovalDashboardDto | undefined>>;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
    placeholder?: string;
}

export enum DashboardTab {
    Drafts = 'drafts',
    Requests = 'requests',
    Instruments = 'instruments',
}
